/**
 * Calculates given seconds to milliseconds
 * @param {Number} seconds
 * @return {Number} milliseconds else 0
 */
export const secondsToMilliseconds = (seconds = 0) => {
  const isValid = typeof seconds === 'number';

  if (!isValid) {
    return 0;
  }

  return seconds * 1000;
};
